import PromoBlock from './PromoBlock';

export default PromoBlock;
